import React from 'react';
import logo from '../assets/images/horizontalLogoWhite.png';

const Header = () => {
    return (
        <header className="bg-pcc-black flex justify-between items-center">
            <div className="flex items-center p-4">
                <img src={logo} alt="University Logo" className="h-16 w-auto" />
            </div>

        </header>
    );
};

export default Header;
